import { Job } from './interfaces';

export const getJobs = async (): Promise<Job[]> => {
  return (await fetch(process.env.REACT_APP_STRAPI_URL + 'jobs')).json();
};
